import React, { useState, useEffect, useContext } from 'react';
import md5 from 'md5';
import dayjs from 'dayjs';

import { FaReply } from 'react-icons/fa';
import { PostComment } from 'src/components/Comments/PostComment/PostComment';
import {
  CommentBlock,
  CommentHeader,
  CommentStatus,
  CommentGravatar,
  CommentUser,
  CommentDate,
  CommentReply,
  CommentText,
  CommentFooter,
  CommentReplies,
  LoginText,
} from 'src/components/Comments/Comment/Comment.style';
import { TextButton } from '@riac/design-system';

import { LoginContext } from 'src/lib/LoginContext';
import { AccountContext } from 'src/lib/AccountContext';

import { ICommentProps } from 'src/components/Comments/Comment/Comment.i';

export const Comment = ({ post, comment, account, status }: ICommentProps) => {
  const { isLoggedIn } = useContext(LoginContext);
  const { getAdmin, isAdmin } = useContext(AccountContext);
  const [toggle, setToggle] = useState(false);
  const [pending, setPending] = useState([]);

  const getReplies = async () => {
    if(isLoggedIn) {
      const status = isAdmin ? 'Admin' : 'Pending';
      const commentId = comment ? comment.ID : '';
      const additionalReq = await fetch(`/api/ghost/getBlogReply${status}/${post.id}/${commentId}`, { credentials: 'include' });
      const additional = isLoggedIn ? await additionalReq.json() : [];
      setPending(isLoggedIn ? additional : []);
    }
  };

  useEffect(() => {
    getAdmin();
    getReplies();
  }, []);

  return (
    <CommentBlock>
      <CommentHeader>
        {status && <CommentStatus>This comment is waiting for approval.</CommentStatus>}
        <CommentGravatar
          src={`https://www.gravatar.com/avatar/${md5(comment.Email || '')}?r=g&d=mp`}
          alt='Avatar'/>
        <CommentUser>{comment.Nickname ? comment.Nickname : `${comment.FirstName} ${comment.LastName}`}</CommentUser>
        <CommentDate>{dayjs(comment.PostDate).format('MMMM DD, YYYY')}</CommentDate>
      </CommentHeader>
      <CommentText>{comment.Comments}</CommentText>
      {!status
        && <CommentFooter>
          <CommentReply onPress={() => setToggle(!toggle)}>
            <FaReply /> Reply
          </CommentReply>
        </CommentFooter>
      }
      {toggle
        && <React.Fragment>
          {isLoggedIn
            && <PostComment
              post={post}
              update={() => getReplies()}
              commentId={comment.ID}
              account={account}
              handleCancel={() => setToggle(false)}
            />
          }
          {!isLoggedIn && <LoginText>Please <TextButton to='/login'>login</TextButton> to reply.</LoginText>}
        </React.Fragment>
      }
      {(comment.Replies && comment.Replies.length > 0) && comment.Replies.map((reply) => (
        <CommentReplies key={reply.ID}>
          <CommentHeader >
            <CommentGravatar
              src={`https://www.gravatar.com/avatar/${md5(reply.Email || '')}?r=g&d=mp`}
              alt='Avatar'/>
            <CommentUser>{reply.Nickname ? reply.Nickname : `${reply.FirstName} ${reply.LastName}`}</CommentUser>
            <CommentDate>{dayjs(reply.PostDate).format('MMMM DD, YYYY')}</CommentDate>
          </CommentHeader>
          <CommentText>{reply.Comments}</CommentText>
        </CommentReplies>
      ))}
      {pending.length > 0 && pending.map((reply) => (
        <CommentReplies key={reply.ID}>
          <CommentHeader >
            <CommentStatus>This comment is waiting for approval.</CommentStatus>
            <CommentGravatar
              src={`https://www.gravatar.com/avatar/${md5(reply.Email || '')}?r=g&d=mp`}
              alt='Avatar'/>
            <CommentUser>{reply.Nickname ? reply.Nickname : `${reply.FirstName} ${reply.LastName}`}</CommentUser>
            <CommentDate>{dayjs(reply.PostDate).format('MMMM DD, YYYY')}</CommentDate>
          </CommentHeader>
          <CommentText>{reply.Comments}</CommentText>
        </CommentReplies>
      ))}
    </CommentBlock>
  );
};
